module.exports = "/img/spartan_bg_mobile.jpg?f5ce9af8e19ea7924fccc19c6c30faae";